/**
 * Feb-2026 (Bug-Fix 26 May) — Image URL normalizer.
 *
 * Bilder werden in der DB teils als absolute Preview-URLs gespeichert (z. B.
 * aus früheren Sandbox-Umgebungen wie `ride-shop-test.preview.emergentagent.com`).
 * Wenn sich die Preview-URL ändert, sind diese Links tot. Diese Helper-Funktion
 * erkennt alte `*.preview.emergentagent.com/api/files/...` URLs und schreibt sie
 * auf den **aktuellen** Backend-Host um (`REACT_APP_BACKEND_URL` → die Datei
 * liegt physikalisch auf dem Persistenz-Volume, das die Preview-URL überlebt).
 *
 * Außerdem: relative `/api/files/...` Pfade werden zum absoluten Backend-URL
 * umgeschrieben, damit `<img src>` ohne weiteres Routing funktioniert.
 */
const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

const PREVIEW_HOST_RE = /^https?:\/\/[^/]*\.preview\.emergentagent\.com/i;

export function normalizeImageUrl(url) {
    if (!url || typeof url !== "string") return url;
    // 1) Relative /api/... → an aktuelles Backend hängen
    if (url.startsWith("/api/")) return BACKEND + url;
    // 2) Alte Preview-Host-Pfade → durch das aktuelle Backend ersetzen
    if (PREVIEW_HOST_RE.test(url)) return url.replace(PREVIEW_HOST_RE, BACKEND);
    // 3) Sonst unverändert lassen (externe CDNs, Unsplash-Fallback, Data-URIs)
    return url;
}

export function normalizeImageList(urls) {
    if (!Array.isArray(urls)) return urls;
    return urls.map(normalizeImageUrl);
}
